import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { Button, Divider, Spinner, Text } from "@chakra-ui/react";
import { getPlaceOfBusinessIconByTypeForInventories } from "../../utils/invetory";
import { MdOutlineAddBusiness } from "react-icons/md";
import ModalSearchInAllInvnetories from "../../components/Modal/ModalSearchInAllInventories";
import dayjs from "dayjs";

type PlaceOfBusiness = {
    id: string,
    name: string,
    address: string,
    companyName: string,
    companyId: string,
    type: number
}

const Inventory = () => {
    const { t } = useTranslation("translations");

    const [placeOfBusiness, setPlaceOfBusiness] = useState<PlaceOfBusiness[]>([]);
    const [sortedPlaceOfBusiness, setSortedPlaceOfBusiness] = useState<{ [key: string]: PlaceOfBusiness[] }>({});
    const [globalSearchModal, setGlobalSearchModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const fetch = async () => {
        setLoading(true);
        try {
            const res = await getAxiosInstance().get("/Companies/places-of-business");
            let tmp: { [key: string]: PlaceOfBusiness[] } = {};
            for (const d of res.data) {
                const index = Object.keys(tmp).findIndex((x) => x === d.companyName);
                if (index !== -1) {
                    tmp[d.companyName].push(d);
                } else {
                    tmp[d.companyName] = [d];
                }
            }
            setSortedPlaceOfBusiness(tmp);
            setPlaceOfBusiness(res.data);
        } catch (e) {
            toast.error(t("UNABLE_TO_FETCH_DATA"), { position: "bottom-right" });
        } finally {
            setLoading(false);
        }
    }

    const downloadHistory = async (companyId: string, name: string = "istoric") => {
        try {
            const response = await getAxiosInstance().get(`/Inventory/history/${companyId}`, { params: { onDate: dayjs(new Date()).format("YYYY-MM-DD") }, responseType: "blob" });

            const href = URL.createObjectURL(response.data);

            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', name + '.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);

        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetch();
    }, []);

    return (
        <>
            <div>
                {
                    loading && <Spinner className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                }
            </div>
            <div className="p-1 flex justify-between">
                <Text className="ml-2" fontSize="2xl" fontWeight="bold">{t("INVENTORIES")}</Text>
                <Button
                    onClick={() => setGlobalSearchModal(true)}
                >
                    {t("GENERAL_INVENTORY_SEARCH")}
                </Button>
            </div>
            <Divider className="mt-2" />
            <div className="relative w-[100vw] h-full p-4">
                {
                    Object.keys(sortedPlaceOfBusiness).map((x: string, index: number) => (
                        <div key={`place_of_business_${index}`}>
                            <div className="flex flex-row justify-between">
                                <Text fontWeight="bold" className="my-2" fontSize="xl">
                                    {x.toUpperCase()}
                                </Text>
                                <Button
                                    onClick={() => downloadHistory(sortedPlaceOfBusiness[x][0].companyId, x)}
                                    className="mr-4"
                                >
                                    Descarca
                                </Button>
                            </div>
                            <div className="flex flex-row flex-wrap">
                                {
                                    sortedPlaceOfBusiness[x].map((y) =>
                                        <a
                                            key={`place-of-business-${index}`}
                                            href={`/inventories/${y.id}`}
                                            className="min-w-[150px] w-fit h-[150px] z-60 bg-neutral-300/30 shadow-inner hover:scale-110 flex flex-col justify-center items-center rounded-[15px] m-2 p-2"
                                        >
                                            {getPlaceOfBusinessIconByTypeForInventories(y.type)}
                                            <Text fontWeight="bold" className="mt-1" fontSize="xl">
                                                {y.name}
                                            </Text>
                                            <Text fontWeight="normal text-slate-950" fontSize="sm">
                                                {y.companyName}
                                            </Text>
                                        </a>
                                    )
                                }
                            </div>
                        </div>
                    ))
                }
                {
                    placeOfBusiness.length === 0 &&
                    <div className="w-full flex flex-col justify-center items-center opacity-60">
                        <MdOutlineAddBusiness className="w-[300px] h-[300px]" />
                        <div className="text-[32px]">{t("NO_INVENTORY_ENTRIES")}</div>
                    </div>
                }
                <ModalSearchInAllInvnetories
                    isOpen={globalSearchModal}
                    onClose={() => setGlobalSearchModal(false)}
                />
            </div>
        </>
    )
};

export default Inventory;